module.exports = __webpack_public_path__ + "static/media/flood1.1443e3c7.jpg";